import React, { useState, useEffect } from 'react';
import { Button, Checkbox, ProgressLinear } from '@americanexpress/dls-react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import styles from './styles/occPreferences.scss';
import FormattedRichMessage from '../common/FormattedRichMessages';
import { getMasterCommData
// getAccounts,
// getCardList, //commenting for mock data
} from '../../services/occ.service';
import useOccEmail from '../../utils/hooks/useOccEmail';
import { useOCC } from './context/occContext';
import { processCommCodes, filterByMasterData, mergeMasterWithGPC, buildSavePayload, getCommType, processCardData, processCardEligibility,
// buildGPCPayloadForPFlow,   //commenting for mock data
buildProductDisplayList } from '../../utils/occUtils';
import { postPrivacyPreferenceSearchDetails, updatePrivacyPreferences } from '../../services/privacy.service';
import { getCardToken, getEnv } from '../../redux/selectors';
import { cardResponseData, GpcResponse } from './MockResponse';
const handleCommCodeResult = (result, navigate) => {
  if (result.error) {
    // navigate('/occ/optouterror');
    return true;
  }
  if (result.redirect === 'globalOptOut') {
    navigate('/ipp');
    return true;
  }
  if (result.redirect === 'occLogin') {
    navigate('/occ/login');
    return true;
  }
  return false;
};
const buildSelectedCommDetail = (masterData, code) => {
  var _masterData$code$COMM, _masterData$code$COMM2, _masterData$code$COMM3, _masterData$code$COMM4, _masterData$code$COMM5;
  return {
    communCode: code,
    communTitle: (_masterData$code$COMM = masterData[code].COMMUN_TITLE_TX) === null || _masterData$code$COMM === void 0 ? void 0 : _masterData$code$COMM.trim(),
    communDescription: (_masterData$code$COMM2 = masterData[code].COMMUN_DS_TX) === null || _masterData$code$COMM2 === void 0 ? void 0 : _masterData$code$COMM2.trim(),
    communSampleLink: masterData[code].COMMUN_SAMP_LNK_TX,
    communTypeCode: (_masterData$code$COMM3 = masterData[code].COMMUN_TYPE_CD) === null || _masterData$code$COMM3 === void 0 ? void 0 : _masterData$code$COMM3.trim(),
    isCommunActive: masterData[code].COMMUN_STA_CD,
    communStatus: 'I',
    code,
    title: (_masterData$code$COMM4 = masterData[code].COMMUN_TITLE_TX) === null || _masterData$code$COMM4 === void 0 ? void 0 : _masterData$code$COMM4.trim(),
    description: (_masterData$code$COMM5 = masterData[code].COMMUN_DS_TX) === null || _masterData$code$COMM5 === void 0 ? void 0 : _masterData$code$COMM5.trim(),
    checked: true
  };
};
function buildSelectedCommDetailsList(masterData, validatedSelectedCodes = []) {
  const selectedCommDetailsList = [];
  const codes = Array.isArray(validatedSelectedCodes) ? validatedSelectedCodes : [];
  codes.forEach(code => {
    selectedCommDetailsList.push(buildSelectedCommDetail(masterData, code));
  });
  return selectedCommDetailsList;
}
const resolveFinalPreferences = async ({
  emailAddress,
  masterData,
  validatedSelectedCodes,
  selectedCommDetailsList,
  typeInfo,
  hasZyncCodes,
  navigate
  // cardToken,
  // env,
}) => {
  if (!typeInfo) {
    return null;
  }
  if (typeInfo.isSubscription && !hasZyncCodes) {
    const gpcResponse = await postPrivacyPreferenceSearchDetails({
      emailAddress,
      preferenceCodes: validatedSelectedCodes
    });

    // if (!gpcResponse) {
    //   navigate('/occ/optouterror');
    //   return null;
    // }

    return mergeMasterWithGPC(masterData, gpcResponse, validatedSelectedCodes);
  }
  if (typeInfo.isProduct || hasZyncCodes) {
    var _gpcResponse$entityPr;
    // ACCOUNTS API CODE
    // const accountResponse = await getAccounts(emailAddress, env);
    // if (!accountResponse) {
    //   navigate('/occ/optouterror');
    //   return null;
    // }

    // const accountDetails = accountResponse?.account_details || [];
    // const encryptedAccounts = accountDetails.map((item) => item.account_token);

    // if (encryptedAccounts.length === 0) {
    //   // navigate('/ipp');
    //   return null;
    // }
    // MAIN API CALL FOR CARD LIST
    // const cardResponse = await getCardList(encryptedAccounts, cardToken, env);
    const cardResponse = cardResponseData; // Mock response for testing
    console.log(cardResponse);
    const cards = processCardData(cardResponse);
    if (cards.length === 0) {
      navigate('/ipp');
      return null;
    }
    const {
      completeData,
      noOfCorpCards
    } = processCardEligibility(cards, masterData);
    // if (!completeData) {
    //   navigate('/occ/optouterror');
    //   return null;
    // }

    // MAIN API CALL FOR GPC
    // const gpcPayload = buildGPCPayloadForPFlow(
    //   completeData,
    //   validatedSelectedCodes
    // );
    // const gpcResponse = await postPrivacyPreferenceSearchDetails({
    //   emailAddress,
    //   preferenceCodes: gpcPayload,
    // });

    const gpcResponse = GpcResponse; // Mock response for testing
    console.log('GPC Response:', gpcResponse);
    // if (!gpcResponse) {
    //   navigate('/occ/optouterror');
    //   return null;
    // }

    const gpcList = (gpcResponse === null || gpcResponse === void 0 || (_gpcResponse$entityPr = gpcResponse.entityPreferenceResponse) === null || _gpcResponse$entityPr === void 0 ? void 0 : _gpcResponse$entityPr.preferenceCodeDetails) || [];
    const displayList = buildProductDisplayList({
      completeData,
      gpcList,
      emailAddress,
      noOfCorpCards,
      selectedCommDetailsList
    });
    const originCode = validatedSelectedCodes[0];
    const originPresent = displayList.some(d => {
      var _d$communCode;
      return ((_d$communCode = d.communCode) === null || _d$communCode === void 0 ? void 0 : _d$communCode.trim()) === originCode;
    });
    if (!originPresent && masterData[originCode]) {
      displayList.push({
        ...selectedCommDetailsList.find(s => s.communCode === originCode),
        communStatus: 'I'
      });
    }
    return displayList.map(item => ({
      code: item.communCode || item.code,
      title: item.communTitle || item.title,
      description: item.communDescription || item.description,
      type: item.communTypeCode || item.type,
      checked: (item.communStatus || item.checked) === 'I' || item.checked === true
    }));
  }
  return [];
};
const OCCPreferencePage = () => {
  const {
    params,
    setSavedPreferences,
    setInitialPreferences
  } = useOCC();
  const navigate = useNavigate();
  const [preferences, setPreferences] = useState([]);
  const [offersPreference, setOffersPreference] = useState(null);
  const [unsubscribeAll, setUnsubscribeAll] = useState(false);
  const [loading, setLoading] = useState(true);
  const emailObj = useOccEmail();
  const cardToken = useSelector(getCardToken);
  const env = useSelector(getEnv);

  // ─── Handle individual checkbox toggle ──────────────────────────────────────
  const handleToggle = (code, isChecked) => {
    const updated = preferences.map(item => {
      if (item.code === code) {
        return {
          ...item,
          checked: isChecked
        };
      }
      return item;
    });
    setPreferences(updated);
    setUnsubscribeAll(updated.every(item => !item.checked));
  };
  const handleOffersToggle = isChecked => {
    setOffersPreference(prev => ({
      ...prev,
      checked: isChecked
    }));
  };

  // ─── MAIN FLOW ───────────────────────────────────────────────────────────────
  useEffect(() => {
    if (!(emailObj !== null && emailObj !== void 0 && emailObj.emailAddress)) return;
    const fetchData = async () => {
      try {
        const result = processCommCodes(params);
        if (handleCommCodeResult(result, navigate)) {
          return;
        }
        const {
          multiCommCodes,
          selectedCommCode,
          hasZyncCodes
        } = result;
        console.log('Processed Comm Codes:', result);
        const masterData = await getMasterCommData(env);
        console.log('Master Comm Data:', masterData);

        // if (!masterData || !selectedCommCode) {
        //   navigate('/occ/optouterror');
        //   return;
        // }

        const validatedSelectedCodes = filterByMasterData(masterData, multiCommCodes);
        console.log('Validated Selected Codes:', validatedSelectedCodes);
        // if (validatedSelectedCodes.length === 0) {
        //   navigate('/occ/optouterror');
        //   return;
        // }

        const selectedCommDetailsList = buildSelectedCommDetailsList(masterData, validatedSelectedCodes);
        console.log('Selected Comm Details List:', selectedCommDetailsList);
        const typeInfo = getCommType(validatedSelectedCodes[0], masterData);
        console.log('Comm Type Info:', typeInfo);
        // if (!typeInfo) {
        //   navigate('/occ/optouterror');
        //   return;
        // }
        if (!typeInfo) {
          setLoading(false);
          return;
        }
        const finalPreferences = await resolveFinalPreferences({
          emailAddress: emailObj.emailAddress,
          masterData,
          validatedSelectedCodes,
          selectedCommDetailsList,
          typeInfo,
          hasZyncCodes,
          navigate,
          cardToken,
          env
        });
        if (!finalPreferences) {
          return;
        }
        console.log('Final Preferences:', finalPreferences);
        setLoading(false);
        const selectedItem = finalPreferences.find(p => p.code === selectedCommCode);
        const restPreferences = finalPreferences.filter(p => p.code !== selectedCommCode);
        setOffersPreference(selectedItem || null);
        setPreferences(restPreferences.length > 0 ? restPreferences : []);
        setInitialPreferences(restPreferences.length > 0 ? restPreferences : []);
      } catch (error) {
        Promise.resolve(error);
        setLoading(false);
        // navigate('/occ/optouterror');
        console.log('Error in OCCPreferencePage useEffect:', error);
      }
    };
    fetchData();
  }, [emailObj, params, navigate, setInitialPreferences]);
  const handleUnsubscribeAll = isChecked => {
    setUnsubscribeAll(isChecked);
    setPreferences(preferences.map(item => ({
      ...item,
      checked: !isChecked
    })));
  };

  // ─── Save ────────────────────────────────────────────────────────────────────
  const handleSave = async () => {
    try {
      const allPreferences = offersPreference ? [offersPreference, ...preferences] : preferences;
      const preferenceRequestGroup = buildSavePayload(allPreferences, unsubscribeAll);
      const response = await updatePrivacyPreferences({
        emailAddress: emailObj.emailAddress,
        preferenceRequestGroup
      });
      setSavedPreferences(preferences);
      if ((response === null || response === void 0 ? void 0 : response.responseCode) === 'SUCCESS') {
        navigate('/occ/updateProductNewsletter', {
          state: {
            mode: 'save'
          }
        });
      } else {
        navigate('/occ/optouterror');
      }
    } catch (error) {
      Promise.resolve(error);
      navigate('/occ/optouterror');
    }
  };
  const handleCancel = () => {
    navigate('/occ/updateProductNewsletter', {
      state: {
        mode: 'cancel'
      }
    });
  };

  // ─── Render ──────────────────────────────────────────────────────────────────
  return /*#__PURE__*/React.createElement("div", {
    className: styles['occ-preferences-container']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['occ-section']
  }, /*#__PURE__*/React.createElement("h2", null, /*#__PURE__*/React.createElement(FormattedRichMessage, {
    id: "occPref.title"
  })), /*#__PURE__*/React.createElement("p", {
    className: styles['sub-text']
  }, /*#__PURE__*/React.createElement(FormattedRichMessage, {
    id: "occPref.subtitle"
  })), loading ? /*#__PURE__*/React.createElement(ProgressLinear, null) : /*#__PURE__*/React.createElement("div", {
    className: styles['unsubscribe-box']
  }, /*#__PURE__*/React.createElement(Checkbox, {
    id: (offersPreference === null || offersPreference === void 0 ? void 0 : offersPreference.code) || 'selected-comm',
    checked: (offersPreference === null || offersPreference === void 0 ? void 0 : offersPreference.checked) ?? false,
    onChange: e => {
      var _e$target;
      const checked = (e === null || e === void 0 || (_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.checked) ?? e;
      handleOffersToggle(checked);
    },
    label: (offersPreference === null || offersPreference === void 0 ? void 0 : offersPreference.title) || /*#__PURE__*/React.createElement(FormattedRichMessage, {
      id: "offer"
    })
  }), /*#__PURE__*/React.createElement("p", {
    className: styles.desc
  }, (offersPreference === null || offersPreference === void 0 ? void 0 : offersPreference.description) || /*#__PURE__*/React.createElement(FormattedRichMessage, {
    id: "occPref.offerText"
  })))), /*#__PURE__*/React.createElement("div", {
    className: `${styles['occ-section']} ${styles.secondary}`
  }, /*#__PURE__*/React.createElement("p", {
    className: styles['section-title']
  }, /*#__PURE__*/React.createElement(FormattedRichMessage, {
    id: "occPref.section2Title"
  })), /*#__PURE__*/React.createElement("div", {
    className: styles['preferences-list']
  }, preferences.map(item => /*#__PURE__*/React.createElement("div", {
    key: item.code,
    className: styles['pref-item']
  }, /*#__PURE__*/React.createElement(Checkbox, {
    id: item.code,
    checked: item.checked,
    onChange: e => {
      var _e$target2;
      const checked = (e === null || e === void 0 || (_e$target2 = e.target) === null || _e$target2 === void 0 ? void 0 : _e$target2.checked) ?? e;
      handleToggle(item.code, checked);
    },
    label: item.title
  }), /*#__PURE__*/React.createElement("p", {
    className: styles.desc
  }, item === null || item === void 0 ? void 0 : item.description)))), /*#__PURE__*/React.createElement("div", {
    className: styles['unsubscribe-all']
  }, /*#__PURE__*/React.createElement(Checkbox, {
    id: "unsubscribe-all",
    checked: unsubscribeAll,
    onChange: e => {
      var _e$target3;
      const checked = (e === null || e === void 0 || (_e$target3 = e.target) === null || _e$target3 === void 0 ? void 0 : _e$target3.checked) ?? e;
      handleUnsubscribeAll(checked);
    },
    label: /*#__PURE__*/React.createElement(FormattedRichMessage, {
      id: "occPref.unsubscribeAll",
      values: {
        email: emailObj === null || emailObj === void 0 ? void 0 : emailObj.maskedEmail
      }
    })
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.actions
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "secondary",
    onClick: handleCancel
  }, /*#__PURE__*/React.createElement(FormattedRichMessage, {
    id: "cancel"
  })), /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    onClick: handleSave
  }, /*#__PURE__*/React.createElement(FormattedRichMessage, {
    id: "savePreferences"
  })))));
};
export default OCCPreferencePage;